export type PackagingWorkOrderIdentity = {
  workOrderNo: string;
  productCode: string;
  workOrderStatus?: "PENDING";
  sourceRow?: number;
  sourceWorkOrderNo?: string | null;
};

export function isPackagingWorkOrderPending(row: PackagingWorkOrderIdentity): boolean {
  return row.workOrderStatus === "PENDING";
}

/** Keeps an explicitly blank Excel cell distinct from the operational SİP AÇ placeholder. */
export function packagingSourceWorkOrderLabel(row: PackagingWorkOrderIdentity): string {
  if (row.sourceWorkOrderNo === null) return "Excel’de boş";
  return row.sourceWorkOrderNo ?? row.workOrderNo;
}

/** Pending rows have no real order identity, so their source rows keep them isolated. */
export function packagingWorkOrderKey(row: PackagingWorkOrderIdentity): string {
  if (isPackagingWorkOrderPending(row)) {
    if (!Number.isInteger(row.sourceRow) || (row.sourceRow ?? 0) <= 0) {
      throw new Error("Bekleyen iş emri için kaynak satırı gerekli.");
    }
    return JSON.stringify(["PENDING", row.sourceRow, row.productCode]);
  }
  return JSON.stringify(["ORDER", row.workOrderNo, row.productCode]);
}
